/**
 * Helper function of login, saves header info, if user is logged in
 * return info from cache
 * @param contentType
 * @returns Object
 */
export function userRequestHeaders(contentType) {
	if (typeof contentType === 'undefined') {
		contentType = "application/json";
	}

	const headers = {
		'Accept': 'application/json',
		'Content-Type': contentType
	};

	const token = sessionStorage.getItem('token');

	if (token !== null && token !== '') {
        headers["Authorization"] = "Bearer " + token;
	}

	return headers;
}
